module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-type-blurbs element-with-heading",
    attrs: {
      "id": "praise-for-anita-waller"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "praise-for-anita-waller-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise for Anita Waller")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "praise-for-anita-waller-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("T")]), _vm._v("his is")]), _vm._v(" a dark domestic chiller that gradually creeps under your skin until the very shocking and unexpected climax.\" "), _c('b', [_vm._v("Joanne Robertson - My Chestnut Reading "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Tree")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("A")]), _vm._v("n excellent suspense filled read,")]), _vm._v(" and I'm looking forward to reading the sequel, Strategy.\" "), _c('b', [_vm._v("Mark Tilbury - "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Author")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("O")]), _vm._v("h my goodness")]), _vm._v(" this book gripped me!  I sat and read this book in one sitting over the weekend and honestly, I really didn't want to put it down...\" "), _c('b', [_vm._v("Donna Maguire - Donnas Book "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Blog")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("T")]), _vm._v("he story is well versed")]), _vm._v(" and the characters kept me intrigued throughout.\" "), _c('b', [_vm._v("Louise Mullins - "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Author")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("S")]), _vm._v("tunning,")]), _vm._v(" brilliant, gripping, heart breaking and touching!\" "), _c('b', [_vm._v("Misfits Farm - Goodreads "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Reviewer")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("M")]), _vm._v("y God")]), _vm._v(" ...this story is heart breaking yet such a pageturner...There are secrets...lies..betrayal ..murder... And a darkness ...so terrifying.... that lurks almost invisible.\" "), _c('b', [_vm._v("Livia Sbarbaro - Goodreads "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Reviewer")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("B")]), _vm._v("eware:")]), _vm._v(" when you pick up the book you won’t be able to let it go before you have reached the final chapter.\" "), _c('b', [_vm._v("Caroline Vincent - Bits About "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Books")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("A")]), _vm._v(" brilliant follow")]), _vm._v(" on book from Beautiful . Kept me guessing until the end.\" "), _c('b', [_vm._v("Angela Lockwood - Goodreads "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Reviewer")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("I")]), _vm._v("t certainly had")]), _vm._v(" me on the edge of my seat and the author is certainly making a name for herself in the psychological genre.\""), _c('b', [_vm._v(" Sarah Hardy - By The Letter Book "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Reviews")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("T")]), _vm._v("his book scared")]), _vm._v(" the daylights out of me and I mean that in the best way possible.\" "), _c('b', [_vm._v("Amy Sullivan - "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Novelgossip")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("T")]), _vm._v("he author writes well,")]), _vm._v(" weaving the story and sucking the reader into the lives of the characters within the book.\" Rebecca Burnton - "), _c('b', [_vm._v("If Only I Could Read "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Faster")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("T")]), _vm._v("his is")]), _vm._v(" book has all the elements needed to make it creepy, read-through-your-fingers-at-times kind of read. There is spooky suspense on every page.\""), _c('b', [_vm._v(" M.A. Comley - New York Times and USA Today best-selling "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("author")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bdd44a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise-for-anita-waller.vue
// module id = 72
// module chunks = 0